import React from 'react';

export interface ConfirmDialogProps {
  isOpen: boolean;
  type: 'priceChange' | 'unsavedChanges' | 'sensitiveChange';
  title: string;
  message: string;
  details?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  warningLevel?: 'info' | 'warning' | 'danger';
}

const ProjectUpdateConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  type,
  title,
  message,
  details,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  loading = false,
  warningLevel = 'warning'
}) => {
  if (!isOpen) return null;

  const getIconForType = () => {
    switch (type) {
      case 'priceChange':
        return 'bi-currency-dollar';
      case 'unsavedChanges':
        return 'bi-exclamation-triangle';
      case 'sensitiveChange':
        return 'bi-shield-exclamation';
      default:
        return 'bi-question-circle';
    }
  };

  const getButtonClass = () => {
    switch (warningLevel) {
      case 'danger':
        return 'btn-danger';
      case 'warning':
        return 'btn-warning';
      case 'info':
        return 'btn-primary';
      default:
        return 'btn-warning';
    }
  };

  return (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog">
        <div className="dialog-header">
          <h4>
            <i className={`bi ${getIconForType()}`}></i>
            {title}
          </h4>
          <button
            className="close-btn"
            onClick={onCancel}
            disabled={loading}
          >
            <i className="bi bi-x"></i>
          </button>
        </div>

        <div className="dialog-content">
          <p>{message}</p>
          {details && (
            <div className={`details-text ${warningLevel === 'danger' ? 'warning-text' : ''}`}>
              {details}
            </div>
          )}
        </div>

        <div className="dialog-actions">
          <button
            className="btn-secondary"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button
            className={getButtonClass()}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading && <i className="bi bi-arrow-clockwise spin"></i>}
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectUpdateConfirmDialog;